export default "__VITE_ASSET__7bceef54__"